import { Suspense, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// Chakra imports
import { Box, Flex, useColorModeValue } from "@chakra-ui/react";

// Layout components
import { SidebarContext } from "common/contexts/SidebarContext";
import Spinner from "common/components/spinner/Spinner";

// Import only auth routes to avoid circular dependencies
import { authRoutes } from "common/routes.js";

// Custom Chakra theme
export default function Auth({ setIsLogin }) {
  // states and functions
  const [toggleSidebar, setToggleSidebar] = useState(false);

  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/auth/full-screen-maps";
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            element={<prop.component />}
            key={key}
          />
        );
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      if (prop.category) {
        return getRoutes(prop.items);
      } else {
        return null;
      }
    });
  };

  const authBg = useColorModeValue("white", "navy.900");
  document.documentElement.dir = "ltr";

  const checkUrlForNavigation = () => {
    const url = window.location.href;
    if (url.includes("#/auth/reset-password")) {
      return "/auth/reset-password";
    } else return "/auth/sign-in";
  };

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Box
          bg={authBg}
          float="right"
          minHeight="100vh"
          position="relative"
          w="100%"
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          {getRoute() ? (
            <Box mx="auto" height="100%">
              <Suspense
                fallback={
                  <Flex
                    justifyContent={"center"}
                    alignItems={"center"}
                    width="100%"
                    height={"100vh"}
                  >
                    <Spinner />
                  </Flex>
                }
              >
                <Routes>
                  {getRoutes(authRoutes)}
                  <Route
                    path="/*"
                    element={<Navigate to={checkUrlForNavigation()} />}
                  />
                </Routes>
              </Suspense>
            </Box>
          ) : null}
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}